import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "../lib/seo";

const RELATED = [["/terms-and-conditions","Terms & Conditions"],["/shipping-policy","Shipping Policy"],["/return-refund-policy","Return & Refund Policy"],["/cancellation-policy","Cancellation Policy"]];

export default function PrivacyPolicy() {
  useSEO({
    title: "Privacy Policy — PrintMyTees",
    description: "Read the PrintMyTees Privacy Policy covering customer information, local device storage, payment information, service providers and data security.",
  });

  return (
    <main className="container-pmt py-10 sm:py-16 max-w-4xl">
      <div className="overline text-[#E34F26]">PrintMyTees</div>
      <h1 className="mt-3 font-black text-3xl sm:text-4xl md:text-5xl uppercase">Privacy Policy</h1>
      <p className="mt-3 text-sm text-stone-600">Last updated: October 2026</p>
      <div className="mt-8 sm:mt-10 space-y-8 sm:space-y-10 text-stone-700 leading-7">
        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">1. Information We Collect</h2>
          <p className="mt-2">When you place an order or contact PrintMyTees, we may collect your name, mobile number, email address, delivery address, order details, and customization requirements.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">2. How We Use Your Information</h2>
          <p className="mt-2">We use this information to process orders, arrange delivery, provide customer support, communicate about your order, and improve our products and services.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">3. Payments</h2>
          <p className="mt-2">Online payments are processed through our payment gateway. PrintMyTees does not require you to share your card, UPI PIN, banking password, or other confidential payment credentials with us.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">4. Sharing of Information</h2>
          <p className="mt-2">We may share necessary information with payment, delivery, and service providers only when required to complete your order or provide the requested service.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">5. Data Security</h2>
          <p className="mt-2">We take reasonable steps to protect customer information. However, no internet-based service can guarantee absolute security.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">6. Local Device Storage</h2>
          <p className="mt-2">Checkout may save details locally on the customer's device to make future checkout faster. These details are sent to PrintMyTees when the customer places an order.</p>
        </section>

        <section>
          <h2 className="text-xl sm:text-2xl font-bold text-stone-900">7. Privacy Questions</h2>
          <p className="mt-2">For privacy-related questions, customers can use the PrintMyTees support contact provided through the website.</p>
        </section>
      </div>
      <div className="mt-10 sm:mt-12 border border-[#E6DFD5] bg-[#F3EDE2] p-5 sm:p-6">
        <div className="overline">Related Policies</div>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {RELATED.map(([to,label]) => (
            <Link key={to} to={to} className="btn-outline-pmt text-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D95328] focus-visible:ring-offset-2">{label}</Link>
          ))}
        </div>
      </div>
      <Link to="/" className="inline-block mt-8 sm:mt-10 btn-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D95328] focus-visible:ring-offset-2">Back to Home</Link>
    </main>
  );
}
